export default "__VITE_ASSET__rPForNNf__"